import React, { useState } from 'react';
import { BellIcon, BriefcaseIcon, MessageCircleIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
import Card from '../components/ui/Card';
const Notifications: React.FC = () => {
  const [notifications, setNotifications] = useState([{
    id: '1',
    type: 'application',
    title: 'Application Status Update',
    message: 'Your application for Senior React Developer at SpaceX is now in review.',
    time: '2 hours ago',
    read: false
  }, {
    id: '2',
    type: 'job',
    title: 'New Job Match',
    message: 'We found 5 new jobs that match your profile.',
    time: '1 day ago',
    read: false
  }, {
    id: '3',
    type: 'message',
    title: 'New Message',
    message: 'You received a message from the hiring manager at Google.',
    time: '2 days ago',
    read: true
  }, {
    id: '4',
    type: 'application',
    title: 'Interview Invitation',
    message: 'Google has invited you for an interview for the Frontend Engineer position.',
    time: '3 days ago',
    read: true
  }, {
    id: '5',
    type: 'job',
    title: 'Job Alert',
    message: 'New UX Designer position at Apple matches your preferences.',
    time: '4 days ago',
    read: true
  }]);
  const markAsRead = (id: string) => {
    setNotifications(notifications.map(notif => notif.id === id ? {
      ...notif,
      read: true
    } : notif));
  };
  const markAllAsRead = () => {
    setNotifications(notifications.map(notif => ({
      ...notif,
      read: true
    })));
  };
  const getIcon = (type: string) => {
    switch (type) {
      case 'application':
        return <ClockIcon size={20} className="text-purple-500 dark:text-purple-400" data-id="element-361" />;
      case 'job':
        return <BriefcaseIcon size={20} className="text-blue-500 dark:text-blue-400" data-id="element-362" />;
      case 'message':
        return <MessageCircleIcon size={20} className="text-green-500 dark:text-green-400" data-id="element-363" />;
      default:
        return <BellIcon size={20} className="text-teal-500 dark:text-teal-400" data-id="element-364" />;
    }
  };
  const unreadCount = notifications.filter(n => !n.read).length;
  return <div className="p-4 pb-20" data-id="element-365">
      <div className="flex items-center justify-between mb-6" data-id="element-366">
        <div data-id="element-367">
          <h1 className="text-2xl font-bold" data-id="element-368">Notifications</h1>
          <p className="text-gray-600 dark:text-gray-400" data-id="element-369">
            {unreadCount} unread notification{unreadCount !== 1 ? 's' : ''}
          </p>
        </div>
        {unreadCount > 0 && <button className="text-sm text-teal-500 dark:text-teal-400 hover:underline" onClick={markAllAsRead} data-id="element-370">
            Mark all as read
          </button>}
      </div>
      <div className="space-y-4" data-id="element-371">
        {notifications.map(notification => <Card key={notification.id} className={`relative ${!notification.read ? 'border-l-4 border-l-teal-500' : ''}`} onClick={() => markAsRead(notification.id)} data-id="element-372">
            <div className="flex" data-id="element-373">
              <div className="mr-4 p-2 rounded-full bg-gray-100 dark:bg-gray-800" data-id="element-374">
                {getIcon(notification.type)}
              </div>
              <div className="flex-1" data-id="element-375">
                <h3 className="font-medium text-gray-900 dark:text-gray-100" data-id="element-376">
                  {notification.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm mt-1" data-id="element-377">
                  {notification.message}
                </p>
                <p className="text-gray-500 dark:text-gray-500 text-xs mt-2" data-id="element-378">
                  {notification.time}
                </p>
              </div>
              {!notification.read && <div className="h-2 w-2 rounded-full bg-teal-500" data-id="element-379"></div>}
            </div>
          </Card>)}
        {notifications.length === 0 && <div className="flex flex-col items-center justify-center py-12" data-id="element-380">
            <div className="bg-gray-100 dark:bg-gray-800 rounded-full p-6 mb-6" data-id="element-381">
              <BellIcon size={48} className="text-gray-400 dark:text-gray-500" data-id="element-382" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2" data-id="element-383">
              No notifications yet
            </h2>
            <p className="text-gray-600 dark:text-gray-400 text-center" data-id="element-384">
              When you receive notifications, they'll appear here.
            </p>
          </div>}
      </div>
    </div>;
};
export default Notifications;